{
  "common.actions.buscar": {
    "defaultMessage": "Suchen"
  },
  "common.actions.close": {
    "defaultMessage": "Schließen"
  },
  "common.actions.createEntity": {
    "defaultMessage": "Erstellen"
  },
  "common.actions.edit": {
    "defaultMessage": "Bearbeiten"
  },
  "common.actions.select": {
    "defaultMessage": "Auswählen..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Alle auswählen"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Auswahl aufheben"
  },
  "common.actions.share": {
    "defaultMessage": "Teilen"
  },
  "common.actions.view": {
    "defaultMessage": "Anzeigen"
  },
  "common.apiError.body": {
    "defaultMessage": "Bitte versuchen Sie es in Kürze erneut. {br}Kontaktieren Sie uns, wenn der Fehler weiterhin auftritt."
  },
  "common.apiError.title": {
    "defaultMessage": "Server antwortet nicht"
  },
  "common.confirmationModal.cancelBtnText": {
    "defaultMessage": "Abbrechen"
  },
  "common.confirmationModal.confirmBtnText": {
    "defaultMessage": "Bestätigen"
  },
  "common.copyBtn.copied": {
    "defaultMessage": "Kopiert"
  },
  "common.fatalError.body": {
    "defaultMessage": "Versuchen Sie, zur Startseite zurückzukehren. Wenn das Problem weiterhin besteht, melden Sie sich erneut an oder kontaktieren Sie uns."
  },
  "common.fatalError.loginAgainBtn": {
    "defaultMessage": "Anmelden"
  },
  "common.fatalError.refreshBtn": {
    "defaultMessage": "Zur Startseite"
  },
  "common.fatalError.title": {
    "defaultMessage": "Etwas ist schiefgelaufen"
  },
  "common.fileInput.btnText": {
    "defaultMessage": "Dateien auswählen"
  },
  "common.form.cancelBtnText": {
    "defaultMessage": "Abbrechen"
  },
  "common.form.dateRange.endDatePlaceholder": {
    "defaultMessage": "Bis"
  },
  "common.form.dateRange.startDatePlaceholder": {
    "defaultMessage": "Von"
  },
  "common.form.errorNotification": {
    "defaultMessage": "Ein Fehler ist aufgetreten. {br}Bitte überprüfen Sie alle Felder und versuchen Sie es erneut."
  },
  "common.form.exitCancelBtnText": {
    "defaultMessage": "Weiter bearbeiten"
  },
  "common.form.exitConfirmBtnText": {
    "defaultMessage": "Ohne Speichern verlassen"
  },
  "common.form.exitPrompt": {
    "defaultMessage": "Möchten Sie abbrechen? {br}Nicht gespeicherte Änderungen gehen verloren."
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Speichern"
  },
  "common.form.savedBtnText": {
    "defaultMessage": "Gespeichert"
  },
  "common.form.updateBtnText": {
    "defaultMessage": "Aktualisieren"
  },
  "common.form.updatedBtnText": {
    "defaultMessage": "Aktualisiert"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Sprache"
  },
  "common.listFilter.apply": {
    "defaultMessage": "Anwenden"
  },
  "common.listFilter.reset": {
    "defaultMessage": "Zurücksetzen"
  },
  "common.noResults": {
    "defaultMessage": "Keine Ergebnisse"
  },
  "common.pagination.countText": {
    "defaultMessage": "Anzeige {showCount, plural, =0 {keine Einträge} one {# Eintrag} other {# Einträge}} von {totalCount}"
  },
  "common.reset": {
    "defaultMessage": "Zurücksetzen"
  },
  "common.text.clear": {
    "defaultMessage": "Leeren"
  },
  "common.timezoneSelect.defaultLabel": {
    "defaultMessage": "Zeitzone"
  },
  "common.viewError.actions.back": {
    "defaultMessage": "Zurück"
  },
  "common.viewError.actions.home": {
    "defaultMessage": "Zur Startseite"
  },
  "common.viewError.actions.retry": {
    "defaultMessage": "Erneut versuchen"
  },
  "common.viewError.details.toggle": {
    "defaultMessage": "Technische Details"
  },
  "common.viewError.error.help": {
    "defaultMessage": "Versuche es erneut. Wenn das Problem bestehen bleibt, kontaktiere uns."
  },
  "common.viewError.error.title": {
    "defaultMessage": "Diese Informationen konnten nicht geladen werden"
  },
  "common.viewError.forbidden.help": {
    "defaultMessage": "Wenn du Zugriff haben solltest, wende dich an eine Administratorin oder einen Administrator."
  },
  "common.viewError.forbidden.title": {
    "defaultMessage": "Du hast keine Berechtigung, das zu sehen"
  },
  "common.viewError.notFound.help": {
    "defaultMessage": "Das Element existiert nicht oder wurde gelöscht. Prüfe den Link oder gehe zurück zur Liste."
  },
  "common.viewError.notFound.title": {
    "defaultMessage": "Wir konnten nicht finden, was du gesucht hast"
  },
  "common.viewError.unavailable.help": {
    "defaultMessage": "Prüfe deine Verbindung und versuche es in einigen Momenten erneut."
  },
  "common.viewError.unavailable.title": {
    "defaultMessage": "Verbindung nicht möglich"
  },
  "stream.thumbnails.empty": {
    "defaultMessage": "Keine Miniaturansichten verfügbar"
  },
  "stream.thumbnails.loading": {
    "defaultMessage": "Miniaturansichten werden geladen"
  },
  "common.resultsCount": {
    "defaultMessage": "{count, plural, zero {Keine Ergebnisse} one {1 Ergebnis gefunden} other {# Ergebnisse gefunden}}"
  }
}
